/**
 * Created by yniran on 12/13/14.
 */
define(function (require) {
    "use strict";

    // tell webpack to pack the sounds. TODO: copy plugin
    require.context(
        '!file-loader?name=[path][name].[ext]!./../../../assets/sounds',
        false,
        /.*/
    );

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        LEConfig = require("assets/config/le-env-conf"),
        ChatWindowLayout = require("connection-views/layouts/chatTab/ChatWindowLayout"),
        ChatWindowContentView = require("connection-views/chatTab/ChatWindowContentView"),
        ChatWindowCoBrowseController = require("connection-controllers/chatTab/ChatWindowCoBrowseController"),
        ChatWindowInputView = require("connection-views/chatTab/ChatWindowInputView"),
        ChatWindowConnectingView = require("connection-views/chatTab/ChatWindowConnectingView"),
        soundFileHelper = require("connection-utils/soundFileHelper"),
        chatLineFormatter = require("connection-utils/chatLineFormatter"),
        ChatInputModel = require("connection-models/chatTab/ChatInputModel"),
        ChatWindowController = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        ChatWindowController = Marionette.Controller.extend({

            initialize: function (options) {
                logger.debug("initialize : entered", "ChatWindowController.initialize");

                this._connectionPanelContextModel = options.contextModel;

                this._chatChannel = options.chatChannel;
                this._messagingAgent = options.agentMessagingModel;
                this._chatContentView = null;
                this._pendingChatLines = null;
                this._chatContactName = "";
                this._lastFormattedLine = null;
                this._chatInformation = null;
                this._chatInfoDepQueue = $.Deferred();
                this._inputModel = new ChatInputModel();
                this._userSentChatLines = false; //used to determine whether to show lines from user that come through the API event, if false then need to show the lines
                this._waitingForSurvey = false;
                this._userClosedChat = false;
                this._chatInProgress = false;  //should only be set to true once a chat is in progress
                this._waitingForChat = false;
                this._lineSoundFiles = null; //will be populated with the sound file names mapping for line types
                this._playSounds = this._connectionPanelContextModel.get("isSoundEnabled");
                this._waitingForSurveyTimeoutHandler = null;

                this._renderLayout();
                this._bindEvents();
                this._initSounds();

                new ChatWindowCoBrowseController({chatVent: this._chatChannel.vent});

            },

            _bindEvents: function () {

                var cVent = this._chatChannel.vent;

                this.listenTo(cVent, "chatStartData:info:ready", this._onChatInfoRetrieved);
                this.listenTo(cVent, "chatConnection:state", this._onChatConnectionState);
                this.listenTo(cVent, "chatConnection:chat:lines", this._onChatLines);
                this.listenTo(cVent, "chatConnection:chat:agentTyping", this._onAgentTyping);
                this.listenTo(cVent, "chatConnection:exitSurvey:info", this._onExitSurveyInfo);
                this.listenTo(cVent, "chat:chatTabActivated", this._setOpenChatRead);
                this.listenTo(this._chatWindowLayout, "chat:close:button:click", this._onChatCloseClick);
                this.listenTo(this._chatWindowLayout, "conversation:back:button:click", this._onBackButtonClick);
                this.listenTo(this._inputModel, "change:chatLine", this._onUserEnteredChatLine);
                this.listenTo(this._inputModel, "change:userTyping", this._onUserTyping);
                this.listenTo(this._chatWindowLayout._chatVent, "chat:back:button:clicked", this._exitChatUI);
                this.listenTo(this._connectionPanelContextModel, "change:isSoundEnabled", this._onSoundStateChange);
                this._chatChannel.reqres.setHandler("cpChatUI::chatWindowController:userClosedChat", this._getUserClosedChat, this);
                this._chatChannel.reqres.setHandler("cpChatUI::chatWindowController::chatInProgress", this._getChatInProgress, this);
                this._chatChannel.comply("cpChatUI::chatWindowController:exitChatUI", this._exitChatUI, this);
            },

            _renderLayout: function () {

                this._chatWindowLayout = new ChatWindowLayout({chatVent: this._chatChannel.vent, model: this._messagingAgent});
                this._chatChannel.vent.trigger("cpChatUI::showRegion:chatWindow", {view: this._chatWindowLayout});

                this._showWindowParts();
            },

            _initSounds: function () {

                var files = {};
                var loc = LEConfig.connectionPanelSettings.chat.soundFilesLocation;

                files[CP_CONST.CHAT_LINE_TYPES.AGENT] = loc + "agentSoundEffect";             //file extensions are assigned by the sounds helper
                files[CP_CONST.CHAT_LINE_TYPES.ANOTHER_AGENT] = files[CP_CONST.CHAT_LINE_TYPES.AGENT];
                files[CP_CONST.CHAT_LINE_TYPES.INFO] = loc + "systemSoundEffect";
                files[CP_CONST.CHAT_LINE_TYPES.SNIPPET] = loc + "kpSoundEffect";

                this._lineSoundFiles = files;
            },

            _onUserEnteredChatLine: function (model, value) {

                logger.debug("user entered chat line: " + value, "ChatWindowController._onUserEnteredChatLine");

                this._userSentChatLines = true;

                var userChatLine = chatLineFormatter.getUserLineFromText({
                    text: value,
                    name: CP_CONST.CHAT_DEFAULT_USER_NAME, //todo: use the name of the currently logged in user if available
                    time: new Date(),
                    lastLine: this._lastFormattedLine,
                    profileAvatar: this._chatInformation.profileAvatarImg
                });

                this._inputModel.set("chatLine", "", {silent: true}); //reset so user can send the same text one after the other

                this._lastFormattedLine = userChatLine;
                this._chatChannel.vent.trigger("chat:sendLine:update", userChatLine); //update the chat api controller to send the new user line
                this._chatChannel.vent.trigger("cpChatUI::new:lines", [userChatLine]); //update the content view to show the new user line
            },

            _onAgentTyping: function (data) {

                logger.debug("received agent typing state event", "ChatWindowController._onAgentTyping", data);

                if (this._chatContactName) {
                    this._chatChannel.vent.trigger("cpChatUI::agentTyping:update", {typing: data.agentTyping, name: this._chatContactName});
                }
            },

            _onUserTyping: function (model, value) {
                logger.debug("user typing state update: " + value, "ChatWindowController._onUserTyping");

                this._chatChannel.vent.trigger("chat:userTyping:update", {typing: value});
            },

            _onBackButtonClick: function(){
                this._chatChannel.vent.trigger("chatConnection:chat:close");
            },

            _onChatCloseClick: function () {
                logger.debug("chat close button clicked", "ChatWindowController._onChatCloseClick");

                this._setWaitingForSurveyResponse(true);
                this._chatChannel.vent.trigger("chat:close:request");

                this._exitChatUI();
            },

            _setWaitingForSurveyResponse: function (userClosed) {
                logger.debug("waiting for survey response - showing loader", "ChatWindowController._waitingForSurveyResponse");

                if (this._waitingForSurveyTimeoutHandler) {    //be nice and clean up
                    clearTimeout(this._waitingForSurveyTimeoutHandler);
                    this._waitingForSurveyTimeoutHandler = null;
                }

                this._waitingForSurveyTimeoutHandler = setTimeout(_.bind(this._onSurveyWaitTimeout, this),
                    LEConfig.connectionPanelSettings.chat.waitForSurveyTimeout); //schedule a timeout so in case something breaks, the loader doesnt get stuck

                this._userClosedChat = userClosed;
                this._waitingForSurvey = true;
                this._chatWindowLayout.showLoader();//show loader on entire chat window layout
            },

            _onSurveyWaitTimeout: function () {

                logger.debug("survey wait timed out - not waiting for survey anymore ! ", "ChatWindowController._onSurveyWaitTimeout");
                this._onExitSurveyInfo({retrieved: false});
            },

            _addDependencyMethodForChatInfo: function (callback) {

                if (this._chatInformation) {
                    callback();
                }
                else {
                    this._chatInfoDepQueue.then(callback);
                }
            },

            _onChatConnectionState: function (data) {

                var states = CP_CONST.CHAT_STATES;
                logger.debug("chat state event received - state =  " + data.state, "ChatWindowController._onChatConnectionState");

                switch (data.state) {
                    case states.ENDED:
                    case states.NOTFOUND:
                        this._endChatMode();
                        break;
                }

                this._handleStateEvent(data.state);
            },

            _onSoundStateChange: function (model, enabled) {
                this._playSounds = enabled;
            },

            _endChatMode: function () {

                if (!this._waitingForSurvey) {

                    if (this._chatInProgress) {     //chat has taken place, we can show exit survey if there is one
                        this._setWaitingForSurveyResponse(false);
                        this._chatInProgress = false;
                        this._waitingForChat = false;
                    }
                }
            },

            _handleStateEvent: function (chatState) {

                logger.debug("updating UI for chat state, chat state = " + chatState, "ChatWindowController._handleStateEvent");

                var isChatting = (chatState === CP_CONST.CHAT_STATES.CHATTING);
                this._waitingForChat = (chatState === CP_CONST.CHAT_STATES.WAITING);

                if (isChatting) {
                    this._chatInProgress = true;  //chatting in progress - when it ends we should be ready for exit survey
                }

                this._inputModel.set("chatActive", isChatting);
                this._toggleConnectingView();
            },

            _onChatInfoRetrieved: function (info) {

                this._chatInformation = info;
                this._chatInfoDepQueue.resolve();
                this._chatContactName = info.contactDisplayName;

                this._toggleConnectingView();
            },

            _toggleConnectingView: function () {

                var isChatting = this._chatChannel.reqres.request("chatInfo::request:isChatting");
                var isEnded = this._chatChannel.reqres.request("chatInfo::request:isChatEnded");
                var show = !isChatting && !isEnded;

                if (show) {
                    this._showConnectingView();
                }
                else if (this._chatConnectingView) {
                    this._chatWindowLayout.chatConnecting.close();
                    this._chatWindowLayout.toggleConnectingFlag(show);
                    this._chatConnectingView = null;
                }
            },

            _showConnectingView: function () {

                var info = this._chatInformation;

                if (!this._chatConnectingView && info && info.profileAvatarImg && info.contactDisplayName) {

                    var chatContentModel = new Backbone.Model({
                        profileAvatarImg: info.profileAvatarImg,
                        contactAvatarImg: info.contactAvatarImg,
                        contactDisplayName: info.contactDisplayName
                    });

                    logger.debug("opening connecting ui in chat, waiting for chat to start", "ChatWindowController._showConnectingView");
                    this._chatConnectingView = new ChatWindowConnectingView({model: chatContentModel});
                    this._showRegion(this._chatWindowLayout.chatConnecting, this._chatConnectingView);
                    this._chatWindowLayout.toggleConnectingFlag(true);
                }
            },

            _getCurrentChatState: function () {
                return this._chatChannel.reqres.request("chatInfo::request:chatState");
            },

            _onChatLines: function (lines) {

                logger.debug("received chat lines", "ChatWindowController._onChatLines", lines);

                var currentState = this._getCurrentChatState();
                var relLines = this._getRelevantChatLines(lines, currentState); //only take the relevant lines based on the chat state (resuming or not)

                if (this._chatContentView && this._chatContentView.getIsRendered()) {
                    this._addChatLinesToContent(relLines);
                }
                else {

                    if (!this._pendingChatLines) { //first time receiving lines while content view isnt ready yet
                        this.listenToOnce(this._chatContentView, "render", this._onChatContentViewRendered);
                    }

                    if (relLines) {
                        this._pendingChatLines = (this._pendingChatLines || []).concat(relLines);
                    }
                }
            },

            _onExitSurveyInfo: function (options) {

                logger.debug("received info about exit survey: ", "ChatWindowController._onExitSurveyInfo", options);

                this._chatWindowLayout.closeLoader();

                if (this._waitingForSurveyTimeoutHandler) {    //be nice and clean up
                    clearTimeout(this._waitingForSurveyTimeoutHandler);
                    this._waitingForSurveyTimeoutHandler = null;
                }

                if (this._waitingForSurvey) {
                    this._chatWindowLayout.resetOnChatEnded(); //make sure the input is resized back to normal
                }

                this._waitingForSurvey = false;
            },

            _exitChatUI: function(retrievedSurvey){

                this._clearChatContent();

                if (!retrievedSurvey) { //dont trigger if when showing survey, the contact list will be shown on top of the survey
                    this._chatChannel.vent.trigger("chatConnection:chat:close", {});//notify so UI can be arranged to show chat closing
                }
            },

            _onChatContentViewRendered: function () {
                this._addChatLinesToContent(this._pendingChatLines);

                delete this._pendingChatLines;
            },

            _addChatLinesToContent: function (lines) {

                this._addDependencyMethodForChatInfo(_.bind(function () { //make sure chat information is available before formatting the lines

                    var formattedLines = this._getFormattedChatLines(lines);

                    if (formattedLines && formattedLines.length > 0) {
                        logger.debug("about to publish " + formattedLines.length + " formatted chat lines", "ChatWindowController._addChatLinesToContent");

                        this._chatChannel.vent.trigger("cpChatUI::new:lines", formattedLines);
                        this._playNewLineSound(formattedLines);
                    }
                }, this));
            },

            _getFormattedChatLines: function (lines) {
                var formattedLines = [];
                var eventData = {};
                if (lines && lines.length > 0) {
                    _.each(lines, function (line) {

                        var formattedLine = chatLineFormatter.getFormattedLine({
                            line: line,
                            lastLine: this._lastFormattedLine,
                            profileAvatar: this._chatInformation.profileAvatarImg,
                            contactAvatar: this._chatInformation.contactAvatarImg,
                            defaultContactAvatar: this._chatInformation.defaultContactAvatarImg,
                            contactName: this._chatContactName,
                            skillChat: !_.isEmpty(this._chatInformation.skill)
                        });

                        if (formattedLine && formattedLines.indexOf(formattedLine) === -1) { //got a new line

                            formattedLines.push(formattedLine);

                            this._lastFormattedLine = formattedLine;

                            if (!this._chatContactName && formattedLine.lineType === CP_CONST.CHAT_LINE_TYPES.AGENT) {
                                this._chatContactName = formattedLine.by;
                            }

                            _.each(formattedLine.text, function (line) {
                                if (!_.isUndefined(line.slug)) {
                                    eventData.usageToTrack = CP_CONST.USAGE_TO_TRACK.CONTENT.GET_CONTENT_IN_CHAT;
                                    eventData.slug = line.slug;
                                    LEConnection.vent.trigger("UsageTrackingController:track", eventData);
                                }
                            }, this);
                        }

                    }, this);

                    if(this._chatInProgress) {
                        this._chatChannel.vent.trigger('messaging:newChatMessageArrived', this._chatInformation.skill, lines.length);
                    }
                }

                return formattedLines;
            },

            _getRelevantChatLines: function (lines, state) {

                var sources = CP_CONST.CHAT_LINE_SOURCES;
                var remoteLines;

                if (this._userSentChatLines) {        //we're in chat and user has typed lines already which are already showing, not point in showing them again
                    remoteLines = _.filter(lines, function (line) {
                        return (line.source !== sources.VISITOR);
                    });
                }
                else {
                    remoteLines = lines; //if this is the case then we're after a refresh and need to show all lines
                }

                return remoteLines;
            },

            _getUserClosedChat: function() {

                return this._userClosedChat;
            },

            _getChatInProgress: function () {
                return this._chatInProgress;
            },

            _clearChatContent: function () {

                this._lastFormattedLine = null;
                this._chatWindowLayout.resetOnChatEnded();
                this._pendingChatLines = null;
                this._chatContactName = null;

                if (this._chatContentView) {           //replace the current content view with a fresh instance
                    this._chatWindowLayout.closeChatContent();
                    this._chatContentView = null;
                    this._showChatContentView();
                }
            },

            _canPlaySound: function () {
                return this._playSounds && (this._chatInProgress || this._waitingForChat);
            },

            _playNewLineSound: function (lines) {

                var line, fileName;

                if (this._canPlaySound() && this._lineSoundFiles) { //only play sounds if not muted
                    if (lines) {
                        line = lines[lines.length - 1]; //play sound for the last line only

                        if (line.lineType !== CP_CONST.CHAT_LINE_TYPES.VISITOR) {
                            fileName = this._lineSoundFiles[ line.lineType];

                            if (fileName) {
                                soundFileHelper.playSoundFile({fileName: fileName, container: this._chatWindowLayout.$el});//push the audio element to the layout container
                            }
                            else {
                                logger.warn("didn't find sound file for line type: " + line.lineType, "ChatWindowController._playNewLineSound");
                            }
                        }
                    }
                }
            },

            _showWindowParts: function () {

                this._inputView = new ChatWindowInputView({model: this._inputModel, chatVent: this._chatChannel.vent});
                this._showRegion(this._chatWindowLayout.chatInput, this._inputView);

                this._showChatContentView();
            },

            _showChatContentView: function () {
                this._chatContentView = new ChatWindowContentView({chatVent: this._chatChannel.vent});
                this._showRegion(this._chatWindowLayout.chatContent, this._chatContentView);
            },
            _setOpenChatRead: function () {
                if(this._chatInformation && this._chatInformation.skill && this._chatInProgress) {
                    this._chatChannel.vent.trigger('chat:notifications:ChatTabActivated_OngoingChat', this._chatInformation.skill, 0);
                }
            },

            _showRegion: function (region, view) {
                if (this._chatWindowLayout.getIsRendered()) {
                    region.show(view);
                }
                else {
                    this.listenTo(this._chatWindowLayout, "render", function () {
                        region.show(view);
                    });
                }
            },
            onClose: function (){
                this._chatChannel.reqres.removeHandler("cpChatUI::chatWindowController:userClosedChat");
            }
        });
    });

    return ChatWindowController;
});
